import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useClientNameStore = defineStore('clientSelect', () => {
  const clientSelect = ref({
    clientName: [],
  })
  return { clientSelect }
})
